import { OnInit, Component } from '@angular/core';
import { IPageResult } from '../../interfaces/page-result';
import { SettingsService } from '../../services/settings.service';
import { SystemSettingsRow } from 'src/app/interfaces/system-settings';
import { MessageService } from 'primeng';
import { Message } from 'src/app/classes/Message';

@Component({
  selector: 'system-settings',
  styleUrls: ['./system-settings.component.css'],
  templateUrl: './system-settings.component.html',
})
export class SystemSettingsComponent implements OnInit {
  public page: IPageResult<SystemSettingsRow> = {
    items: [],
    total: 0,
  };

  public data: string;
  public isShowSystemSetting: boolean = false;
  public setting: any = {};
  public selectedSetting: any;

  constructor(private settingsService: SettingsService, private messageService: MessageService) {}

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.settingsService.GetSettingsList().then((items) => {
      this.page.items = items;
      this.page.total = items.length;
    });
  }
  editSetting(item) {
    this.setting = Object.assign({}, item);

    console.log('Current setting: ', this.setting);

    this.isShowSystemSetting = true;
  }

  saveSetting(item) {
    this.settingsService.save(item).then((res) => {
      if (res) {
        this.isShowSystemSetting = false;
        var pageItem = this.page.items.find((x) => x.id === item.id);
        pageItem.name = item.name;
        pageItem.value = item.value;
      } else {
        this.messageService.add(Message.Error('Invalid value', 'Error'));
      }
    });
  }

  isTextField(item) {
    return (
      item.id == 1 ||
      item.id == 2 ||
      item.id == 3 ||
      item.id == 10 ||
      item.id == 11 ||
      item.id == 14 ||
      item.id == 15 ||
      item.id == 16 ||
      item.id == 17
    );
  }
}
